var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResidentialChosen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 160,
    height: 198,
    viewBox: "0 0 160 198",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-3,.cls-5{fill:#4b4b4b}.cls-5,.cls-6{stroke:#4b4b4b}.cls-6{fill:#13647b;stroke-miterlimit:10;stroke-width:2.268px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Residential_Chosen",
    transform: "translate(-532 -303)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_340",
    fill: "none",
    d: "M0 0H160V198H0z",
    transform: "translate(532 303)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    fill: "#dcdcdc",
    d: "M20 0A20 20 0 1 1 0 20 20 20 0 0 1 20 0z",
    transform: "translate(548 369)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_346",
    transform: "translate(414.495 256.334)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    d: "M247.051 243.638h-97.867a2.68 2.68 0 0 1-2.679-2.71v-4.415a2.683 2.683 0 0 1 2.675-2.688h2.247v-99.256a4.8 4.8 0 0 1 3.39-4.633l29.688-8.691a4.76 4.76 0 0 1 6.031 4.653v107.784h1.95V111.071a5.381 5.381 0 0 1 5.35-5.4h28.4a5.365 5.365 0 0 1 5.35 5.419v47.979h7.861a5.372 5.372 0 0 1 5.355 5.418v69.343h2.257a2.694 2.694 0 0 1 2.667 2.715v4.41a2.685 2.685 0 0 1-2.677 2.688zm-97.712-2.7zm0-4.282v4.144h97.555v-4.145h-4.924v-72.184a2.54 2.54 0 0 0-2.518-2.573h-10.7v-50.827a2.534 2.534 0 0 0-2.509-2.571h-28.4a2.54 2.54 0 0 0-2.522 2.548v125.468H187.7V125.879a1.928 1.928 0 0 0-1.9-1.972 1.754 1.754 0 0 0-.531.068l-29.642 8.677a1.96 1.96 0 0 0-1.368 1.9v102.107zm97.555-.135zm-28.05-.6h-10.557l.005-11.851a2.545 2.545 0 0 1 2.523-2.565h8.029zm-7.721-2.834h4.887v-8.748h-4.884zm19.3 2.824h-10.557V221.5h9.418v.552a2.552 2.552 0 0 1 1.138 2.128zm-7.722-2.834h4.888v-8.447l-1.138.38v-.674H222.7z",
    className: "cls-3"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_345"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_64",
    fill: "#fff",
    d: "M0 0L90 0",
    transform: "translate(153.311 235.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_298",
    d: "M0 0H90V2.834H0z",
    className: "cls-3",
    transform: "translate(153.311 233.747)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    d: "M180.516 140.593H162.7a1.766 1.766 0 0 0-1.189.428l-.121.109h-.49v3.777a1.57 1.57 0 0 0 1.671 1.53h17.947a1.57 1.57 0 0 0 1.671-1.53v-2.79a1.568 1.568 0 0 0-1.673-1.524zm-.314 3.859h-17.319v-1.338h.131v-.537H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    d: "M180.516 152.17H162.7a1.754 1.754 0 0 0-1.193.433l-.12.109h-.491v3.78a1.57 1.57 0 0 0 1.671 1.529h17.947a1.57 1.57 0 0 0 1.671-1.529v-2.8a1.57 1.57 0 0 0-1.669-1.522zm-.314 3.871h-17.319v-1.355h.131v-.531H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    d: "M180.516 163.757H162.7a1.76 1.76 0 0 0-1.2.437l-.119.11-.486.007v3.763a1.57 1.57 0 0 0 1.671 1.53h17.947a1.57 1.57 0 0 0 1.671-1.53v-2.788a1.57 1.57 0 0 0-1.668-1.529zm-.314 3.862h-17.319v-1.353h.131v-.523H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    d: "M180.516 175.34H162.7a1.76 1.76 0 0 0-1.2.437l-.119.11-.486.007v3.763a1.57 1.57 0 0 0 1.671 1.53h17.947a1.57 1.57 0 0 0 1.671-1.53v-2.788a1.57 1.57 0 0 0-1.668-1.529zm-.316 3.86h-17.317v-1.353h.131v-.523H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    d: "M180.516 186.923H162.7a1.76 1.76 0 0 0-1.2.437l-.119.11-.486.007v3.763a1.57 1.57 0 0 0 1.671 1.53h17.947a1.57 1.57 0 0 0 1.671-1.53v-2.788a1.57 1.57 0 0 0-1.668-1.529zm-.314 3.862h-17.319v-1.353h.131v-.523H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    d: "M180.516 198.506H162.7a1.76 1.76 0 0 0-1.2.437l-.119.11-.486.007v3.763a1.57 1.57 0 0 0 1.671 1.53h17.947a1.57 1.57 0 0 0 1.671-1.53v-2.788a1.57 1.57 0 0 0-1.668-1.529zm-.314 3.862h-17.319v-1.353h.131v-.523H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    d: "M180.516 210.089H162.7a1.757 1.757 0 0 0-1.187.428l-.121.108h-.5v3.775a1.554 1.554 0 0 0 1.671 1.533h17.947a1.57 1.57 0 0 0 1.671-1.53v-2.788a1.57 1.57 0 0 0-1.665-1.526zm-.314 3.862h-17.319v-1.335h.131v-.544H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    d: "M180.516 221.672H162.7a1.762 1.762 0 0 0-1.193.432l-.122.111h-.485v3.771a1.554 1.554 0 0 0 1.671 1.533h17.947a1.57 1.57 0 0 0 1.671-1.53V223.2a1.57 1.57 0 0 0-1.673-1.528zm-.314 3.862h-17.319v-1.878H180.2z",
    className: "cls-5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_299",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 113.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_300",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 126.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_301",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 140.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_302",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 154.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_303",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 167.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_304",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 181.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_305",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 194.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_306",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(200.905 208.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_307",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 113.41)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_308",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 126.99)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_309",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 140.57)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_310",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 154.15)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_311",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 167.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_312",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 181.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_313",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 194.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_314",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(213.905 208.47)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_315",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(226.905 167.73)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_316",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(226.905 181.31)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_317",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(226.905 194.89)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_318",
    width: 9,
    height: 9,
    className: "cls-6",
    rx: 1,
    transform: "translate(226.905 208.47)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResidentialChosen);
export default __webpack_public_path__ + "static/media/residential-chosen.7fbb6398a7a923e53488983529aa5954.svg";
export { ForwardRef as ReactComponent };